<template>
  <main>
    <PageContent :data="getCurrentData" />
  </main>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import EventBus from '@/scripts/event-bus'

import PageContent from '@/components/PageContent'
import getTransition from '@/scripts/transitions'

export default {
  components: {
    PageContent
  },

  data() {
    return {
      isScrolled: false
    }
  },

  props: ['isFirstEnter'],

  computed: {
    ...mapState(['transitions', 'isMenuOpen']),

    ...mapGetters(['getCurrentData', 'getScrollbar', 'currentInSlider', 'checkInSlider'])
  },

  mounted() {
    this.loaded()

    EventBus.$on('scrollTo', (y, time) => this.$smooth.scrollTo(y, time))
  },

  beforeRouteLeave(to, from, next) {
    if (!document.body.classList.contains('progress')) document.body.classList.add('progress')

    this.$store.commit('SET_IS_IN_TRANSITION', true)
    EventBus.$off('scrollTo')

    this.createStateTransition(to.name, from.name)

    getTransition('leave', 'page', this).then(() => {
      this.$smooth.destroyScrollbar()
      next()
    })
  },

  methods: {
    loaded() {
      this.$smooth.initScrollbar().then(() => {
        this.$emit('loaded')

        const transition = this.isFirstEnter ? 'page-enter' : 'page'
        if (this.isFirstEnter) this.createFirstStateTransition()

        getTransition('enter', transition, this).then(() => {
          this.$store.commit('SET_IS_IN_TRANSITION', false)
          this.$smooth.listenScroll()
          this.$smooth.scrollbar.updatePluginOptions('blockScroll', { blocked: false });

          if (document.body.classList.contains('progress')) document.body.classList.remove('progress')
        })
      })
    },

    createStateTransition(to, from) {
      const transition = {
        to,
        from,
        toInSlider: this.checkInSlider(to),
        fromInSlider: this.checkInSlider(from),
        fromMenu: this.isMenuOpen
      }
      this.$store.commit('SET_TRANSITION_STATE', transition)
    },

    createFirstStateTransition() {
      const transition = {
        from: '',
        fromInSlider: false,
        to: this.$route.name,
        toInSlider: this.checkInSlider(this.$route.name),
        fromMenu: false
      }

      this.$store.commit('SET_TRANSITION_STATE', transition)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Page.vue